import React from 'react';
import './Logo.css';

const Logo = ({ className = '' }) => {
  const source = `${process.env.PUBLIC_URL || ''}/brand/curentia-logo.png`;
  return (
    <img
      className={`curentia-logo ${className}`}
      src={source}
      alt="Curentia"
    />
  );
};

export default Logo;
